// TouchscreenHerbal Website Data

export const brandData = {
  name: "TouchscreenHerbal",
  tagline: "Herbal Wellness at Your Fingertips",
  description: "Unlock your body's natural healing potential with our premium herbal remedies, wellness products, and personalized coaching.",
  email: "hello@touchscreenherbal.com",
  phone: "+1 (555) 123-4567",
  instagram: "https://www.instagram.com/touchscreenherbal",
  address: "123 Wellness Way, Natural City, NC 28001"
};

export const productsData = [
  {
    id: 1,
    name: "Soursop Bitters",
    category: "bitters",
    price: 34.99,
    originalPrice: 44.99,
    image: "https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=500&h=500&fit=crop",
    description: "Our signature soursop bitters blend, crafted to support digestive health and boost immunity naturally.",
    benefits: ["Supports Digestion", "Boosts Immunity", "Natural Detox", "Energy Enhancement"],
    rating: 4.9,
    reviews: 127,
    badge: "Best Seller",
    inStock: true
  },
  {
    id: 2,
    name: "Herbal Detox Tea",
    category: "teas",
    price: 24.99,
    image: "https://images.unsplash.com/photo-1564890369478-c89ca6d9cde9?w=500&h=500&fit=crop",
    description: "A gentle yet effective blend of herbs designed to cleanse and rejuvenate your body.",
    benefits: ["Gentle Cleanse", "Supports Liver", "Reduces Bloating", "Antioxidant Rich"],
    rating: 4.8,
    reviews: 89,
    badge: null,
    inStock: true
  },
  {
    id: 3,
    name: "Immunity Boost Tincture",
    category: "tinctures",
    price: 29.99,
    image: "https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=500&h=500&fit=crop",
    description: "Powerful elderberry and echinacea blend to strengthen your natural defenses.",
    benefits: ["Immune Support", "Cold & Flu Defense", "Fast Absorption", "All Natural"],
    rating: 4.9,
    reviews: 156,
    badge: "Popular",
    inStock: true
  },
  {
    id: 4,
    name: "Calming Herbal Blend",
    category: "teas",
    price: 22.99,
    image: "https://images.unsplash.com/photo-1597481499750-3e6b22637e12?w=500&h=500&fit=crop",
    description: "Chamomile, lavender, and passionflower blend for peaceful relaxation and better sleep.",
    benefits: ["Stress Relief", "Better Sleep", "Relaxation", "Caffeine Free"],
    rating: 4.7,
    reviews: 73,
    badge: null,
    inStock: true
  },
  {
    id: 5,
    name: "Digestive Wellness Kit",
    category: "kits",
    price: 79.99,
    originalPrice: 99.99,
    image: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=500&h=500&fit=crop",
    description: "Complete digestive health bundle with bitters, tea, and probiotic support.",
    benefits: ["Complete System", "Gut Health", "30-Day Supply", "Save 20%"],
    rating: 5.0,
    reviews: 64,
    badge: "Bundle",
    inStock: true
  },
  {
    id: 6,
    name: "Energy Vitality Drops",
    category: "tinctures",
    price: 32.99,
    image: "https://images.unsplash.com/photo-1505576399279-565b52d4ac71?w=500&h=500&fit=crop",
    description: "Natural energy boost with ginseng, maca, and adaptogenic herbs.",
    benefits: ["Natural Energy", "Mental Clarity", "No Crash", "Adaptogenic"],
    rating: 4.8,
    reviews: 91,
    badge: null,
    inStock: true
  }
];

export const servicesData = [
  {
    id: 1,
    name: "1:1 Wellness Consultation",
    duration: "60 minutes",
    price: 89,
    description: "Personalized wellness assessment and herbal protocol tailored to your unique needs.",
    includes: ["Health Assessment", "Custom Protocol", "Product Recommendations", "Follow-up Support"]
  },
  {
    id: 2,
    name: "Herbal Coaching Package",
    duration: "4 weeks",
    price: 249,
    description: "Comprehensive 4-week program with weekly sessions and ongoing support.",
    includes: ["4 Weekly Sessions", "Personalized Plan", "Email Support", "Resource Library Access"]
  },
  {
    id: 3,
    name: "Group Wellness Workshop",
    duration: "2 hours",
    price: 45,
    description: "Interactive group sessions covering various wellness topics and herbal education.",
    includes: ["Live Workshop", "Q&A Session", "Take-Home Materials", "Community Access"]
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Charlotte, NC",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face",
    rating: 5,
    text: "The Soursop Bitters completely transformed my digestion. I've been using it for 3 months and feel amazing!",
    product: "Soursop Bitters"
  },
  {
    id: 2,
    name: "Marcus J.",
    location: "Atlanta, GA",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
    rating: 5,
    text: "The wellness consultation was eye-opening. Finally found natural solutions that work for my body.",
    product: "Wellness Consultation"
  },
  {
    id: 3,
    name: "Jennifer L.",
    location: "Miami, FL",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
    rating: 5,
    text: "I sleep so much better with the Calming Herbal Blend. It's now part of my nightly routine.",
    product: "Calming Herbal Blend"
  },
  {
    id: 4,
    name: "David K.",
    location: "Houston, TX",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
    rating: 5,
    text: "Quality products and amazing customer service. TouchscreenHerbal is my go-to for natural wellness.",
    product: "Digestive Wellness Kit"
  }
];

export const instagramPosts = [
  { id: 1, image: "https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=300&h=300&fit=crop", likes: "2.8K" },
  { id: 2, image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=300&h=300&fit=crop", likes: "3.2K" },
  { id: 3, image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=300&h=300&fit=crop", likes: "5.6K" },
  { id: 4, image: "https://images.unsplash.com/photo-1540420773420-3366772f4999?w=300&h=300&fit=crop", likes: "4.1K" },
  { id: 5, image: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=300&h=300&fit=crop", likes: "2.1K" },
  { id: 6, image: "https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=300&h=300&fit=crop", likes: "3.9K" }
];

export const faqData = [
  {
    question: "How do I take the Soursop Bitters?",
    answer: "Take 1-2 tablespoons daily, preferably in the morning before meals. Can be taken straight or mixed with water or juice."
  },
  {
    question: "Are your products organic?",
    answer: "Yes! All our herbs are sourced from certified organic farms and processed without harmful chemicals or additives."
  },
  {
    question: "How long until I see results?",
    answer: "Most customers notice improvements within 2-4 weeks of consistent use. Results vary based on individual health conditions."
  },
  {
    question: "Do you offer international shipping?",
    answer: "Currently we ship within the United States. International shipping coming soon!"
  }
];
